// This component is a workaround for limitations in CRA
// By default, CRA will inject styles into the head of the document
// this is not ideal for us, as we want to render the styles into the
// shadowDOM of the integration web component so that styles apply to our
// app only and not to the whole page.
// For now we decided to do it this way.
import React, { useEffect, useRef } from 'react';
import '../../app.scss';

// define interface for component props and state
interface Props {
  inShadowDOM?: boolean;
}

const Stylesheet = ({ inShadowDOM }: Props) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const head = document.querySelector('head');
    const lastStyle = document.querySelector('style:last-of-type');

    if (inShadowDOM) {
      elementRef.current.appendChild(lastStyle);
    }

    return () => {
      if (inShadowDOM) {
        head.appendChild(lastStyle);
      }
    };
  }, [inShadowDOM]);

  if (inShadowDOM) {
    return <div ref={elementRef} />;
  }

  return null;
};

export default Stylesheet;
